document.addEventListener("DOMContentLoaded", function () {

  const SHEET_URL = 'https://script.google.com/macros/s/AKfycby6fuUvP1AfR4srIQDcBruicZxpk5lfm9aKRXMokcrnvKOGU0Ksb8RSFkl_MaCcpHvHSA/exec';
  const SOURCE = 'predictive_search_widget';
  const MAX_MATCHES = 4;
  const CONFIRM_DURATION_MS = 4500;

  const washerLookup = {
    '42185611935833': '1/8"-1/16"',
    '42185798385753': '1/8"-3/64"',
    '39413231747161': '3/16"-1/16"',
    '42185615245401': '3/16"-1/16" Wide',
    '40463249277017': '3/16"-3/64"',
    '40530473025625': '3/16"-1mm',
    '40952708661337': '3/16"-3/32"',
    '39414273638489': '5mm-1/16"',
    '40463249703001': '5mm-3/64"',
    '40530477416537': '5mm-1mm',
    '40952708595801': '5mm-3/32"',
    '40110757707865': '6mm-1/16"',
    '40952055988313': '6mm-1/16" Semi-Wide',
    '40400418373721': '6mm-1/16" Wide',
    '42716487745625': '6mm-3/64"',
    '40243540623449': '6mm-1mm',
    '39414272327769': '1/4"-1/16"',
    '40293634900057': '1/4"-2mm',
    '40243540754521': '1/4"-1mm',
    '42719510298713': '1/4"-.050"'
  };

  // ─── ONE-TIME STYLE OVERRIDES ──────────────────────────────────────────────
  (function injectStyles() {
    if (document.getElementById('skiff-pred-compat-styles')) return;
    const style = document.createElement('style');
    style.id = 'skiff-pred-compat-styles';
    style.textContent = `
      .skiff-pred-item .predictive-search__item {
        cursor: default;
      }
      .skiff-pred-item:hover .predictive-search__item-heading,
      .skiff-pred-item[aria-selected='true'] .predictive-search__item-heading {
        text-decoration: none;
      }
      .skiff-pred-links {
        margin-top: 0.3rem;
        font-size: 1.3rem;
      }
      .skiff-pred-links a {
        text-decoration: underline;
        text-underline-offset: 0.2rem;
      }
      .skiff-pred-item.skiff-added .predictive-search__item {
        background-color: rgba(60, 160, 100, 0.12);
      }
      .skiff-pred-item.skiff-oos .predictive-search__item {
        background-color: rgba(192, 57, 43, 0.08);
      }
      .skiff-pred-status {
        font-size: 1.3rem;
        margin-top: 0.3rem;
      }
      .skiff-pred-status.skiff-added-text {
        color: rgb(var(--color-foreground));
      }
      .skiff-pred-status.skiff-oos-text {
        color: #c0392b;
      }
      .skiff-pred-status .skiff-view-cart {
        color: rgb(var(--color-foreground));
        text-decoration: underline;
        font-weight: 600;
        margin-left: 0.6rem;
        cursor: pointer;
      }
      .skiff-see-all-wrap {
        padding: 0.8rem 2rem 1.2rem;
      }
      .skiff-see-all-wrap a {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        padding: 0.9rem 1.6rem;
        text-decoration: none;
        font-size: 1.4rem;
        font-weight: 400;
        border-radius: 0.6rem;
        border: 0.1rem solid rgba(var(--color-foreground), 0.25);
        background-color: rgba(var(--color-foreground), 0.04);
      }
      .skiff-see-all-wrap a,
      .skiff-see-all-wrap a:visited,
      .skiff-see-all-wrap a:active,
      .skiff-see-all-wrap a:focus {
        color: rgb(var(--color-foreground));
      }
      .skiff-see-all-wrap a:hover {
        background-color: rgba(var(--color-foreground), 0.08);
      }
      .skiff-scroll-hint {
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2.4rem;
        margin-bottom: -2.4rem;
        background: linear-gradient(to bottom, rgba(var(--color-background), 0) 0%, rgb(var(--color-background)) 85%);
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  })();

  // ─── LOAD COMPAT DATA ONCE ────────────────────────────────────────────────
  let allRows = [];
  let dataReady = false;

  fetch("/pages/bearing-compatibility")
    .then(r => r.text())
    .then(htmlString => {
      const doc = new DOMParser().parseFromString(htmlString, "text/html");
      const rows = doc.querySelectorAll("#compatTable tbody tr");
      allRows = Array.from(rows).map(r => ({
        maker: r.cells[0].textContent.trim(),
        knife: r.cells[1].textContent.trim(),
        links: r.cells[2].innerHTML.trim()
      }));
      dataReady = true;
    })
    .catch(err => console.warn("Skiff compat fetch error:", err));

  function matchRows(term) {
    const filter = term.toLowerCase().trim();
    if (!filter) return [];
    const words = filter.split(/\s+/).filter(Boolean);
    return allRows.filter(r => {
      const combined = (r.maker + " " + r.knife).toLowerCase();
      return words.every(w => combined.includes(w));
    });
  }

  // ─── CART / TRACKING ───────────────────────────────────────────────────────
  var busyRows = new Set();
  var rowTimers = new WeakMap();

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        var count = cart.item_count;
        document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)')
          .forEach(b => b.textContent = count);
        document.querySelectorAll('.cart-count-bubble').forEach(b => {
          if (count > 0) { b.removeAttribute('hidden'); b.style.display = ''; }
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
  }

  function getUtmSource() {
    return new URLSearchParams(window.location.search).get('utm_source') || '';
  }

  function variantIdFromHref(href) {
    var parts = href.split('/');
    return parts[parts.length - 1].split('?')[0];
  }

  function sendToSheet(payload) {
    fetch(SHEET_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(() => {});
  }

  // ─── CONFIRMATION / OUT-OF-STOCK / REVERT ──────────────────────────────────
  function showAdded(item, linksEl, statusEl, originalLinksHTML, model, productLabel) {
    if (rowTimers.has(item)) clearTimeout(rowTimers.get(item));

    item.classList.add('skiff-added');
    linksEl.style.display = 'none';
    statusEl.classList.add('skiff-added-text');
    statusEl.classList.remove('skiff-oos-text');
    statusEl.innerHTML = '✓ ' + productLabel + ' for ' + model + ' added' +
      '<a href="/cart" class="skiff-view-cart">View cart →</a>';
    statusEl.style.display = 'block';

    var timer = setTimeout(function () {
      item.classList.remove('skiff-added');
      statusEl.style.display = 'none';
      statusEl.innerHTML = '';
      linksEl.style.display = '';
      linksEl.innerHTML = originalLinksHTML;
      rowTimers.delete(item);
      busyRows.delete(item);
    }, CONFIRM_DURATION_MS);

    rowTimers.set(item, timer);
  }

  function showOutOfStock(item, linksEl, statusEl, originalLinksHTML) {
    if (rowTimers.has(item)) clearTimeout(rowTimers.get(item));

    item.classList.add('skiff-oos');
    linksEl.style.display = 'none';
    statusEl.classList.add('skiff-oos-text');
    statusEl.classList.remove('skiff-added-text');
    statusEl.textContent = 'Out of stock';
    statusEl.style.display = 'block';

    var timer = setTimeout(function () {
      item.classList.remove('skiff-oos');
      statusEl.style.display = 'none';
      statusEl.textContent = '';
      linksEl.style.display = '';
      linksEl.innerHTML = originalLinksHTML;
      rowTimers.delete(item);
      busyRows.delete(item);
    }, CONFIRM_DURATION_MS);

    rowTimers.set(item, timer);
  }

  function addToCart(variantId, maker, model, productLabel, item, linksEl, statusEl, originalLinksHTML) {
    fetch('/variants/' + variantId + '.js')
      .then(r => r.json())
      .then(variant => {
        if (!variant.available) {
          showOutOfStock(item, linksEl, statusEl, originalLinksHTML);
          return;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId),
            quantity: 1,
            properties: {
              '_knife_maker': maker,
              '_knife_model': model,
              '_widget_source': SOURCE,
              'For': maker + ' ' + model
            }
          })
        })
          .then(r => r.json())
          .then(() => {
            showAdded(item, linksEl, statusEl, originalLinksHTML, model, productLabel);
            updateCartCount();
          })
          .catch(() => { busyRows.delete(item); });
      })
      .catch(() => { busyRows.delete(item); });
  }

  // ─── BUILD THE COMPAT MATCH GROUP ──────────────────────────────────────────
  function buildCompatGroup(matches, term) {
    const group = document.createElement('div');
    group.className = 'predictive-search__result-group skiff-compat-group';
    group.setAttribute('data-skiff-compat', 'true');

    const heading = document.createElement('h2');
    heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    heading.textContent = matches.length > MAX_MATCHES
      ? 'Bearings & Washers (' + matches.length + ')'
      : 'Bearings & Washers';
    group.appendChild(heading);

    const list = document.createElement('ul');
    list.className = 'predictive-search__results-list list-unstyled';
    list.setAttribute('role', 'group');

    matches.slice(0, MAX_MATCHES).forEach((r) => {
      const li = document.createElement('li');
      li.className = 'predictive-search__list-item skiff-pred-item';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.innerHTML =
        '<div class="predictive-search__item">' +
          '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
            '<p class="predictive-search__item-heading h5">' + r.maker + ' ' + r.knife + '</p>' +
            '<div class="skiff-pred-links">' + r.links + '</div>' +
            '<div class="skiff-pred-status" style="display:none;"></div>' +
          '</div>' +
        '</div>';
      list.appendChild(li);
    });

    group.appendChild(list);

    // Prevent focus loss (mousedown) on our action links, which is what was
    // causing the whole dropdown to close before the click could register.
    group.addEventListener('mousedown', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      if (link.classList.contains('skiff-view-cart') || link.classList.contains('skiff-see-all')) return;
      e.preventDefault();
    });

    group.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;

      // Let "View cart" and "See all results" navigate normally.
      if (link.classList.contains('skiff-view-cart') || link.classList.contains('skiff-see-all')) return;

      e.preventDefault();

      var item = link.closest('.skiff-pred-item');
      if (!item || busyRows.has(item)) return;
      busyRows.add(item);

      var linksEl = item.querySelector('.skiff-pred-links');
      var statusEl = item.querySelector('.skiff-pred-status');
      var originalLinksHTML = linksEl.innerHTML;

      var heading = item.querySelector('.predictive-search__item-heading').textContent.trim();
      var parts = heading.split(' ');
      var maker = parts.shift();
      var model = parts.join(' ');

      var variantId = variantIdFromHref(link.href);
      var isWasher = link.title === 'Washers';
      var bearingSize = isWasher ? '' : link.textContent.trim();
      var washerSize = isWasher ? (washerLookup[variantId] || 'unknown') : '';
      var productLabel = isWasher ? washerSize : bearingSize;

      sendToSheet({
        type: 'click',
        maker: maker,
        model: model,
        bearingSize: bearingSize,
        washerSize: washerSize,
        source: SOURCE,
        utmSource: getUtmSource()
      });

      addToCart(variantId, maker, model, productLabel, item, linksEl, statusEl, originalLinksHTML);
    });

    // Show a "see all" link only when results were truncated.
    if (matches.length > MAX_MATCHES) {
      const seeAllWrap = document.createElement('div');
      seeAllWrap.className = 'skiff-see-all-wrap';
      const seeAllLink = document.createElement('a');
      seeAllLink.href = '/pages/bearing-compatibility?q=' + encodeURIComponent(term);
      seeAllLink.className = 'skiff-see-all';
      seeAllLink.innerHTML = '<span>See all ' + matches.length + ' results on the full compatibility sheet</span><span>→</span>';
      seeAllWrap.appendChild(seeAllLink);
      group.appendChild(seeAllWrap);
    }

    return group;
  }

  // ─── BUILD THE "NO MATCHING RESULTS" FALLBACK ─────────────────────────────
  function buildNoResultsMessage() {
    const div = document.createElement('div');
    div.className = 'skiff-no-results';
    div.setAttribute('data-skiff-compat', 'true');
    div.style.padding = '1.5rem 2rem';
    div.style.fontSize = '1.4rem';
    div.style.color = 'rgba(var(--color-foreground), 0.6)';
    div.textContent = 'No matching results.';
    return div;
  }

  // ─── SCROLL HINT: only appears if the dropdown content actually overflows
  // its capped height, so it's a genuine signal rather than a decoration. ──
  function updateScrollHint(container) {
    var isOverflowing = container.scrollHeight > container.clientHeight + 2;
    if (!isOverflowing) return;
    var hint = document.createElement('div');
    hint.className = 'skiff-scroll-hint';
    hint.setAttribute('data-skiff-compat', 'true');
    container.appendChild(hint);
  }

  // ─── HOOK CALLED BY predictive-search.js AFTER EVERY RENDER ───────────────
  window.skiffInjectCompatResults = function (instance) {
    if (!dataReady) return;

    var term = (instance.searchTerm || '').trim();
    var container = instance.predictiveSearchResults;
    if (!container || !term) return;

    var resultsRoot = container.querySelector('#predictive-search-results');
    if (!resultsRoot) return;

    // Clear any previously injected compat content before deciding what to show
    resultsRoot.querySelectorAll('[data-skiff-compat]').forEach(function (el) { el.remove(); });

    var nativeWrapper = resultsRoot.querySelector('#predictive-search-results-groups-wrapper');
    var hasNative = !!nativeWrapper;

    var matches = matchRows(term);
    var hasCompat = matches.length > 0;

    var anchor = nativeWrapper || resultsRoot.querySelector('#predictive-search-option-search-keywords');

    if (hasCompat) {
      var group = buildCompatGroup(matches, term);
      if (anchor) {
        resultsRoot.insertBefore(group, anchor);
      } else {
        resultsRoot.insertBefore(group, resultsRoot.firstChild);
      }
      updateScrollHint(container);
      return;
    }

    if (!hasCompat && !hasNative) {
      var noResults = buildNoResultsMessage();
      var searchForButton = resultsRoot.querySelector('#predictive-search-option-search-keywords');
      if (searchForButton) {
        resultsRoot.insertBefore(noResults, searchForButton);
      } else {
        resultsRoot.insertBefore(noResults, resultsRoot.firstChild);
      }
      updateScrollHint(container);
      return;
    }

    // No compat matches, but native results exist — leave Dawn's output untouched.
    updateScrollHint(container);
  };

});